import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { InventoryAttribute, InventoryItem } from 'src/app/core/models/inventory.model';

@Component({
	selector: 'app-primary-attribute-search-modal',
	templateUrl: './primary-attribute-search-modal.component.html',
	styleUrls: ['./primary-attribute-search-modal.component.scss']
})
export class PrimaryAttributeSearchModalComponent implements OnInit {

	@Input()
	primaryAttributeName: string;

	@Input()
	inventoryItems: InventoryItem[];

	allAttributes = [] as InventoryAttribute[];
	attributes = [] as InventoryAttribute[];

	constructor(
		private modalController: ModalController,
	) { }

	ngOnInit(): void {
		this.allAttributes = this.inventoryItems
			.filter(ii => ii.statusId === 3)
			.map(ii => ii.attributes[0])
			.filter(a => a.value != null)
			.sort((a, b) => a.value > b.value ? 1 : -1);

		this.setAttributes(this.allAttributes);
	}

	private setAttributes(attributes: InventoryAttribute[]) {
		this.attributes = attributes.sort((a, b) => a.value > b.value ? 1 : -1);
	}

	onChangeFilter(input: string) {
		const searchTerm = input.toLowerCase().trim();
		if (!searchTerm) {
			this.attributes = this.allAttributes;
			return;
		}

		const regex = new RegExp(searchTerm, 'gi');
		const attributes = this.allAttributes.filter(a => a.value.match(regex));

		this.setAttributes(attributes);
	}

	async dismiss(attribute?: InventoryAttribute): Promise<void> {
		let truckInventory = null;
		if (attribute) {
			truckInventory = this.inventoryItems.find(ii => ii.attributes[0].value === attribute.value);
		}

		await this.modalController.dismiss({
			dismissed: true,
			truckInventory,
		});
	}

}
